export const handleColors = (status) => {
  const colors = {
    SCHEDULED: 'light-blue lighten-4',
    OPEN: 'orange lighten-4',
    DONE: 'green lighten-4',
    CONFIRMED: 'green lighten-4',
    COMPLETED: 'green lighten-4',
    RECEIVED: 'green lighten-4',
    FINISHED: 'green lighten-4',
    CANCELED: 'grey lighten-2',
    PENDING: 'orange lighten-4',
    PROCESSING: 'blue lighten-4',
    OVERDUE: 'red lighten-4',
    FAILED: 'red lighten-4',
    REALTY: 'realty',
    REAL_ESTATE: 'realEstate',
    OTHER: 'orange darken-4',
    REFUSED: 'red lighten-4',
    AWAITING_APPROVAL: 'orange lighten-4',
    APPROVED: 'green lighten-4',
    CANCELED: 'red lighten-4',
    FAILED: 'red lighten-4',
    PENDING: 'orange lighten-4',
    PROCESSING: 'blue lighten-4',
    COMPLETED: 'green lighten-4',
    DRAFT: 'purple lighten-4',
    REJECTED: 'yellow lighten-4',
    undefined: 'grey lighten-2',
  }

  return colors[status]
}

export const appointmentStatusColors = (status) => {
  const colors = {
    SCHEDULED: 'light-blue lighten-4',
    OPEN: 'lime lighten-4',
    DONE: 'green lighten-4',
    CANCELED: 'red lighten-4',
    undefined: 'grey lighten-4',
  }

  return colors[status]
}

export const paymentTypesColors = (type) => {
  const colors = {
    mission: 'grey lighten-4',
    appointment: 'grey lighten-4',
    detached: 'grey lighten-4'
  }

  return colors[type]
}
